
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.625 50.375c-2.3-2.3-.775-7.125-1.95-9.95C10.5 37.6 6 35.125 6 32c0-3.125 4.45-5.5 5.675-8.425 1.225-2.925-.35-7.65 1.95-9.95 2.3-2.3 7.125-.775 9.95-1.95C26.4 10.5 28.875 6 32 6c3.125 0 5.5 4.45 8.425 5.675 2.925 1.225 7.65-.35 9.95 1.95 2.3 2.3.775 7.125 1.95 9.95C53.5 26.4 58 28.875 58 32c0 3.125-4.45 5.5-5.675 8.425-1.225 2.925.35 7.65-1.95 9.95-2.3 2.3-7.125.775-9.95 1.95C37.6 53.5 35.125 58 32 58c-3.125 0-5.5-4.45-8.425-5.675-2.925-1.225-7.65.35-9.95-1.95z","stroke":"#fff","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M33.8 45a1.8 1.8 0 11-3.6 0 1.8 1.8 0 013.6 0z","fill":"#fff","stroke":"#56BFC7","stroke-width":"2.4"}}),_c('path',{attrs:{"d":"M32 36v-2a7 7 0 10-7-7","stroke":"#56BFC7","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    